import axios from "axios";

// No shared client timeout. A 60s cap aborted slow Managed Services calls
// (certificate file preview included) and left the review pane spinning.
// Per-request timeouts and a visible error when a call runs long are a
// follow-up; certificate-validation sets its own timeout at the call site.
const axiosInstance = axios.create();
export default axiosInstance;
